export default [
    {
        name: 'tag',
        props: {
            label: 'Nombre Tag',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
    {
        name: 'description',
        props: {
            label: 'Descripción',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
]
